'use client';

import { useIsRestoring } from '@tanstack/react-query';
import { BootSplash } from '@/lib/components/BootSplash';

interface PersistGateProps {
  children: React.ReactNode;
}

/** Blocks UI until PersistQueryClientProvider finishes restoring from storage. */
export function PersistGate({ children }: PersistGateProps) {
  const isRestoring = useIsRestoring();
  if (isRestoring) {
    return <BootSplash />;
  }
  return <>{children}</>;
}
